import React from "react";
import { appColors, appType } from "../../utils/appTheme";

/**
 * Gráfico de barras compacto (evolución de pagos).
 * data: [{ label, paid, pending }] con valores en % (0–100).
 * Presentacional puro. Barras: paid=azul, pending=ink@14%.
 */
const MiniBarChart = ({ data = [], height = 118, legend = true, style }) => {
  const pendingColor = "rgba(18,20,26,.14)";
  return (
    <div style={style}>
      <div
        style={{
          display: "flex",
          alignItems: "flex-end",
          gap: 8,
          height,
        }}
      >
        {data.map((d, i) => (
          <div
            key={i}
            style={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "flex-end",
              height: "100%",
              gap: 4,
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "flex-end",
                justifyContent: "center",
                gap: 3,
                height: "100%",
                width: "100%",
              }}
            >
              <span
                style={{
                  width: 8,
                  height: `${Math.max(2, Math.min(100, d.paid || 0))}%`,
                  background: appColors.blue,
                  borderRadius: "4px 4px 0 0",
                }}
              />
              <span
                style={{
                  width: 8,
                  height: `${Math.max(2, Math.min(100, d.pending || 0))}%`,
                  background: pendingColor,
                  borderRadius: "4px 4px 0 0",
                }}
              />
            </div>
            <span style={{ ...appType.caption, fontSize: 10 }}>{d.label}</span>
          </div>
        ))}
      </div>
      {legend && (
        <div style={{ display: "flex", gap: 16, marginTop: 12, justifyContent: "center" }}>
          <LegendItem color={appColors.blue} label="Pagado" />
          <LegendItem color={pendingColor} label="Pendiente" />
        </div>
      )}
    </div>
  );
};

const LegendItem = ({ color, label }) => (
  <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
    <span style={{ width: 10, height: 10, borderRadius: 3, background: color }} />
    <span style={{ ...appType.caption }}>{label}</span>
  </span>
);

export default MiniBarChart;
